import { useEffect, useState } from 'react';
import { useVideo } from '../useVideo';
import { Participant } from 'twilio-video';
import { isRemoteParticipant } from 'utils';

export function useScreenShareParticipant() {
  const { room, isSharingScreen, toggleScreenShare } = useVideo();
  const [screenShareParticipant, setScreenShareParticipant] = useState<Participant>();

  useEffect(() => {
    if (!room) return;

    const localParticipant = room.localParticipant;

    const updateScreenShareParticipant = () => {
      const allParticipants: Participant[] = [...Array.from(room.participants.values()), localParticipant];

      setScreenShareParticipant(
        allParticipants.find((participant) =>
          Array.from(participant.tracks.values()).some((track) => track.trackName?.includes('screen')),
        ),
      );
    };

    updateScreenShareParticipant();

    room.on('trackPublished', updateScreenShareParticipant);
    room.on('trackUnpublished', updateScreenShareParticipant);
    room.on('participantDisconnected', updateScreenShareParticipant);

    localParticipant.on('trackPublished', updateScreenShareParticipant);
    localParticipant.on('trackUnpublished', updateScreenShareParticipant);

    return () => {
      room.off('trackPublished', updateScreenShareParticipant);
      room.off('trackUnpublished', updateScreenShareParticipant);
      room.off('participantDisconnected', updateScreenShareParticipant);

      localParticipant.off('trackPublished', updateScreenShareParticipant);
      localParticipant.off('trackUnpublished', updateScreenShareParticipant);
    };
  }, [room]);

  useEffect(() => {
    if (isSharingScreen && screenShareParticipant && isRemoteParticipant(screenShareParticipant)) {
      toggleScreenShare();
    }
  }, [isSharingScreen, screenShareParticipant, toggleScreenShare]);

  return screenShareParticipant;
}
